const bidErrorMessages = {
  "User must have 'can_edit_bid' permission to update Bid": "У вас недостаточно прав для редактирования данной операции",
  "User must have 'can_edit_self_bid' permission to update Bid": "У вас недостаточно прав для редактирования данной операции",
  "User must have 'can_edit_self_bid' permission to retry Withdrawal": "У вас недостаточно прав для повторной выплаты",
  "Seller is required": "Ошибка: не заполнен продавец",
  "BidRequisite list is empty": "Ошибка: не заполнены реквизиты выплаты",
  "BidItem price_per_unit must be positive": "Ошибка: сумма к выплате должна быть больше нуля",
  "Bid must have Seller": "Ошибка: не заполнен продавец",
  "Bid must have payment_comment": "Не заполнен комментарий к назначению платежа. Заполните и повторите попытку",
  "BidItem quantity <= 0": "Ошибка! Укажите количество в номенклатуре больше нуля",
  "BidItem weight_net <= 0": "Ошибка! Укажите вес в номенклатуре больше нуля",
  "Endpoint not found in Employee endpoints": "Не найден сотрудник в торговой точке",
  "User doesn't have permissions to create DocumentTemplate": "Недостаточно прав на создание шаблона документа. Обратитесь в поддержку",
  "Provided username not unique": "Логин пользователя должен быть уникальным",
  "terminal min amount limit condition failed": "Минимальная сумма выплаты 5000 рублей. Измените сумму выплаты и попробуйте еще раз.",
}

export const translateBidErrorMessage = (message) => {
  if (!message) {
    return "Что-то пошло не так"
  }

  return bidErrorMessages[message] ?? message
}
